module.exports = __webpack_public_path__ + "img/video-btn.5e47cdbb.png";